import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles<{ relative: boolean }>()(
  ({ spacing, palette }, { relative }) => ({
    container: {
      position: relative ? "relative" : "absolute",
      width: "100%",
      height: "100%",
      alignItems: "center",
      justifyContent: "center",
      // Lynsey mock: tight 8px gap between hat / title / description, and 48px
      // padding. The 48px holds under the mp-core array spacing scale; snapcourse's
      // linear themes resolve spacing(7) to 28px instead.
      gap: spacing(2),
      padding: spacing(7),
      backgroundColor: palette.primary[50],
      borderRadius: "3px",
      zIndex: 1
    }
  })
)
